export default __webpack_public_path__ + "static/media/0243.7cacf16d.jpg";